// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';

import type {Tag} from './index';
import {TagTheme} from './types';

export function template(this: Tag) {
  const isBreadcrumb = this.attr(`theme`) === TagTheme.Breadcrumb;
  const isRemoveable = !isBreadcrumb && this.attr(`removable`);

  let sizeClass = `default-tag`;
  switch (this.attr(`size`)) {
    case this.helpers.TagSize.Mini:
      sizeClass = `mini-tag`;
      break;
    case this.helpers.TagSize.Small:
      sizeClass = `small-tag`;
      break;
    case this.helpers.TagSize.Default:
      sizeClass = `default-tag`;
      break;
  }
  return (
    <div
      sel='.mp-tag'
      class={{
        clickable: this.attr(`clickable`),
        removable: this.attr(`removable`),
        [this.attr(`theme`)]: true,
        [sizeClass]: true,
      }}
      on={{click: this.attr(`clickable`) ? this.helpers.select : null}}
    >
      {this.attr(`icon`) ? (
        <div sel='.tag-extra-icon'>
          <SvgIconEl attrs={{icon: this.attr(`icon`)}} />
        </div>
      ) : null}
      <div
        sel='.tag-name'
        class={{truncate: this.attr(`truncate`)}}
        attrs={{elref: `mpTagName`, title: this.attr(`truncate`) ? this.attr(`tag-name`) : undefined}}
      >
        {this.attr(`tag-name`)}
      </div>
      {isBreadcrumb && (
        <div sel='.tag-caret-icon'>
          <SvgIconEl attrs={{icon: `caret-right`}} />
        </div>
      )}
      {isRemoveable && (
        <div sel='.tag-remove-icon' on={{click: this.helpers.remove}}>
          <SvgIconEl attrs={{icon: `x`}} />
        </div>
      )}
    </div>
  );
}
